/* eslint-disable promise/param-names */
import { AUTH_REQUEST, AUTH_REQUEST_TUTOR, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT } from '../actions/auth'
import axios from 'axios'
import {router} from "../../main.js"
import { USER_REQUEST } from '../actions/user'
import apiCall from '../../components/Login/api'

const state = { token: localStorage.getItem('token') || '', status: '', hasLoadedOnce: false }

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status
}

const actions = {
  [AUTH_REQUEST]: ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      apiCall.login({data: user})
      .then(resp => {
        console.log('auth',resp.data)
        //localStorage.setItem('user-token', resp.data.data)
        console.log('refetch_token:'+resp.data.refresh_token)
        localStorage.setItem('jwt_token', resp.data.jwt_token)
        localStorage.setItem('refetch_token', resp.data.refetch_token)
        console.log('token',localStorage.getItem('jwt_token'))
        // Here set the header of your ajax library to the token value.
        // example with axios
      //  axios.defaults.headers.common['Authorization'] = 'Bearer ' + resp.data.jwt_token

        commit(AUTH_SUCCESS, resp)
        //dispatch(USER_REQUEST)
        console.log('done login')
       
        //console.log(localStorage.getItem('user-token'))
        resolve(resp)
      })
      .catch(err => {
        console.log('error',err)
        commit(AUTH_ERROR, err)
        localStorage.removeItem('user-token')
        reject(err)
      })
    })
  },
  [AUTH_REQUEST_TUTOR]: ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST_TUTOR)
      apiCall.tutorLogin({data: user})
      .then(resp => {
        console.log('auth',resp.data)
        //localStorage.setItem('user-token', resp.data.data)
        localStorage.setItem('jwt_token', resp.data.jwt_token)
        console.log('token',localStorage.getItem('jwt_token'))
        // Here set the header of your ajax library to the token value.
        // example with axios
      //  axios.defaults.headers.common['Authorization'] = 'Bearer ' + resp.data.jwt_token

        commit(AUTH_SUCCESS, resp)
        //dispatch(USER_REQUEST)
        console.log('done login')
       
        //console.log(localStorage.getItem('user-token'))
        resolve(resp)
      })
      .catch(err => {
        console.log('error',err)
        commit(AUTH_ERROR, err)
        localStorage.removeItem('user-token')
        reject(err)
      })
    })
  },
  [AUTH_LOGOUT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT)
      document.cookie = "jwt_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      localStorage.removeItem('jwt_token')
      localStorage.removeItem('vuex')
      localStorage.removeItem('refetch_token')
      router.push('/login')
      resolve()
    })
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_REQUEST_TUTOR]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success'
    state.isAuthenticated = true
    state.token = resp.data.jwt_token
    state.hasLoadedOnce = true
    state.role = resp.data.user_role
    state.id = resp.data.user_id
    state.name = resp.data.user_firstname
    state.longname = resp.data.user_firstname + ' '+resp.data.user_lastname
    state.email = resp.data.user_email
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error'
    state.hasLoadedOnce = true
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = ''
  
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/auth.js